import React from 'react';
import { BulletDivider } from '../dividers';
import TimeAgo from '../time-ago/time-ago';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { AUTHOR } from '../../../common/constants/data-hooks';
import { getOwnerName } from '../../../common/store/members/members-selectors';
import { useApi } from '../../context/api-context/use-api';
import { useConfiguration } from '../../context/configuration-context/use-configuration';
import { getIsMaInstalled, getIsMobile, } from '../../../common/store/base-params/base-params-selectors';
import ProfileLink from '../profile-link/profile-link';
import MemberBadgeLazy from '../member-badge/member-badge-lazy';
import MemberCardLazy from '../member-card/member-card-lazy';
import { classes, st } from './user-info.st.css';
import { RoleBadge } from '../role-badge/role-badge';
import { renderNodesWithDivider } from '../../../common/utils/render-nodes-with-divider';
const UserInfo = ({ avatar, owner, timestamp }) => {
    var _a, _b, _c, _d, _e;
    const { roleIcons, roleBadges, hideBadge, hidePublishDate } = useConfiguration();
    const { isMAInstalled, isMobile } = useApi((state) => ({
        isMAInstalled: getIsMaInstalled(state),
        isMobile: getIsMobile(state),
    }));
    const t = useTranslate();
    const [isMemberCardInvoked, showMemberCard] = React.useState(false);
    const elementRef = React.useRef(null);
    const { memberBadge, memberRole, member } = owner.type === 'MEMBER'
        ? {
            memberBadge: (_c = (_b = (_a = owner.member) === null || _a === void 0 ? void 0 : _a.memberBadges) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : undefined,
            memberRole: (_e = (_d = owner.member) === null || _d === void 0 ? void 0 : _d.memberRoles) === null || _e === void 0 ? void 0 : _e[0],
            member: owner.member,
        }
        : {
            memberBadge: undefined,
            memberRole: undefined,
            member: undefined,
        };
    const RoleIcon = memberRole && (roleIcons === null || roleIcons === void 0 ? void 0 : roleIcons[memberRole]);
    const roleBadge = memberRole && (roleBadges === null || roleBadges === void 0 ? void 0 : roleBadges[memberRole]);
    return (React.createElement("div", { ref: elementRef, onMouseOver: () => showMemberCard(true), className: st(classes.root, { isMobile }) },
        isMAInstalled && owner.type === 'MEMBER' && isMemberCardInvoked && elementRef.current && (React.createElement(MemberCardLazy, { viewedMemberId: owner.member.id, elementRef: elementRef.current })),
        avatar ? avatar : null,
        React.createElement("div", { className: classes.content },
            React.createElement(ProfileLink, { className: classes.row, member: member },
                React.createElement("span", { className: classes.username, "data-hook": AUTHOR }, getOwnerName(owner, t)),
                RoleIcon ? (React.createElement("div", { className: classes.roleIcon },
                    React.createElement(RoleIcon, null))) : null,
                roleBadge ? React.createElement(RoleBadge, { className: classes.roleBadge, label: roleBadge === null || roleBadge === void 0 ? void 0 : roleBadge.label }) : null),
            React.createElement("div", { className: classes.row }, renderNodesWithDivider([
                timestamp && !hidePublishDate && (React.createElement(TimeAgo, { className: classes.time, time: timestamp, key: "time-ago" })),
                memberBadge && !hideBadge && (React.createElement(MemberBadgeLazy, { className: classes.badge, badge: memberBadge, key: "member-badge" })),
            ].filter(Boolean), React.createElement(BulletDivider, { className: classes.divider }))))));
};
export default UserInfo;
//# sourceMappingURL=user-info.js.map